// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext'; // تأكد من المسار صح

const ProtectedRoute = ({ children, module, action = 'read' }) => {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();

  // 1. حالة التحميل: نرجع Component بسيط مش null
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="animate-pulse text-blue-900 font-black italic">VERIFYING ACCESS...</div>
      </div>
    );
  }

  // 2. لو مفيش مستخدم: نرجع Navigate Component - ومعاه الصفحة اللي كان رايحها
  // عشان بعد الدخول يرجع لها بدل الداشبورد
  if (!user) {
    return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  // 3. فحص الصلاحية للموديول
  if (module) {
    const isAllowed = hasPermission(module, action);
    
    // سطر ديبج عشان تطمن
    console.log(`🛡️ Guarding [${module}]: ${isAllowed}`);

    if (!isAllowed) {
      // لو ملوش صلاحية يرجع للداشبورد
      return <Navigate to="/dashboard" replace />;
    }
  }

  // 4. السطر ده هو اللي كان بيعمل Error 130 لو الـ children مش جاهزين
  // لازم نضمن إننا بنرجع الـ children كـ React Element
  return <>{children}</>;
};

export default ProtectedRoute;